'use client';

import { useTranslations } from 'next-intl';
import CustomLink from 'components/shared/CustomLink';
import { AfibShopifyMap } from 'content/products/addons/afib';
import { CurrencySymbol, useFormatPrice } from 'hooks/pricing/useFormattedPrice';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { useCartStore, useShallow } from 'components/shared/Cart';
import { CustomImage } from '../custom-image';
import {
  Button,
  ImageContainer,
  InfoModalContainer,
  InfoModalDescription,
  InfoModalTitle,
  PricingModal,
} from './layout';
import { getAssetUrl } from 'lib/config/assetUrls';
import { Currency } from 'utils/Currency';

export const AfibInfoCartModal = () => {
  const t = useTranslations('ring');
  const CartClient = useCartStore(
    useShallow((s) => ({ store: s.store, currency: s.currency })),
  );

  const { store, currency } = CartClient;
  const CurrencyCode = CurrencySymbol[currency ?? Currency.usd];

  const { width } = useWindowSize();
  const formatPriceWithComma = useFormatPrice();

  return (
    <InfoModalContainer>
      <InfoModalTitle>
        <h3>{t('ring.infoModals.afib.title')}</h3>
        <p>
          {t('ring.infoModals.afib.subtitle.a')}
          <>
            {CurrencyCode}
            {formatPriceWithComma(
              AfibShopifyMap[store as ShopifyStore].Year1.price,
            )}
          </>
          {t('ring.infoModals.afib.subtitle.b')}
        </p>
        <ImageContainer className="afib-container">
          <CustomImage
            src={`web_v2/cart-info-modals/afib_detection${
              width > 1024 ? '_desktop' : ''
            }.png`}
            width={1388}
            height={1133}
            alt={t('ring.infoModals.afib.imageAlt')}
            priority
          />
        </ImageContainer>
      </InfoModalTitle>
      <InfoModalDescription>
        <p>{t('ring.infoModals.powerplugs')}</p>
        <p>
          <strong>{t('ring.infoModals.afib.descriptionStrong')}</strong>{' '}
          {t('ring.infoModals.afib.description')}
        </p>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.afib.text.a.title')}</h3>
        <p>{t('ring.infoModals.afib.text.a.p1')}</p>
        <p>{t('ring.infoModals.afib.text.a.p2')}</p>
      </InfoModalDescription>
      <InfoModalDescription>
        <h3>{t('ring.infoModals.afib.text.b.title')}</h3>
        <p>{t('ring.infoModals.afib.text.b.p1')}</p>
      </InfoModalDescription>
      <ImageContainer className="screen">
        <CustomImage
          src="web_v2/cart-info-modals/afib_complications.png"
          width={1388}
          height={798}
          alt={t('ring.infoModals.afib.complicationsAlt')}
          priority
        />
      </ImageContainer>
      <CustomLink
        rel="noopener noreferrer"
        // TODO: check this
        // href={getAssetUrl('/web_v2/downloads/afib-report.pdf')}
        href={getAssetUrl('/web_v2/downloads/afib-report-v2.pdf')}
        title={t('ring.infoModals.afib.reportTitle')}
        target={'_blank'}
      >
        <Button>
          <span>{t('ring.infoModals.afib.button')}</span>
        </Button>
      </CustomLink>
    </InfoModalContainer>
  );
};

export const AfibPricingModal = () => (
  <PricingModal>
    <AfibInfoCartModal />
  </PricingModal>
);
